import axios from 'axios';

import {OutgoingMessage, OutgoingMessageFilters, PaginatedData} from 'types';

import {API_URL} from './constants';

const getActiveMessages = async (
    filters: OutgoingMessageFilters,
    pagination: {page: number, pageSize: number}
): Promise<PaginatedData<OutgoingMessage>> => {
    const res = await axios.post(`${API_URL}/outgoing-messages/active`, {filters, pagination});
    return res.data;
};

const getHistoryMessages = async (
    filters: OutgoingMessageFilters,
    pagination: {page: number, pageSize: number}
): Promise<PaginatedData<OutgoingMessage>> => {
    const res = await axios.post(`${API_URL}/outgoing-messages/history`, {filters, pagination});
    return res.data;
};

const removeActiveMessage = async (id: string) => {
    const res = await axios.delete(`${API_URL}/outgoing-messages/active/${id}`);
    return res.data;
};

const removeHistoryMessage = async (id: string) => {
    const res = await axios.delete(`${API_URL}/outgoing-messages/history/${id}`);
    return res.data;
};

const exportHistory = async (filters: OutgoingMessageFilters, {page}, labels) => {
    const response = await axios.post(`${API_URL}/outgoing-messages/export/history`, {labels, pagination: {page}, filters});
    return response.data;
};

export const outgoingMessagesApi = {
    getActiveMessages,
    getHistoryMessages,
    removeActiveMessage,
    removeHistoryMessage,
    exportHistory
};